module.exports = __webpack_public_path__ + "img/39.075fde75.png";